export const tableConstants = {
    SET_TABLE_CONFIG: "SET_TABLE_CONFIG",
    UPDATE_TABLE_CONFIG: "UPDATE_TABLE_CONFIG"
}; 